import React from "react";
import { useController } from "react-hook-form";
import PropTypes from "prop-types";
import { Form } from "@weezevent/nacre";

/**
 * A generic counter component integrated with react-hook-form.
 */
const FormFieldCounter = ({
	name,
	control,
	onChange: onExternalChange,
	...props
}) => {
	const {
		field: { onChange, value },
		fieldState: { error }
	} = useController({
		name: name,
		control
	});

	const onChangeValue = React.useCallback(
		(_, newValue) => {
			onChange(newValue);
			if (onExternalChange) {
				onExternalChange(newValue);
			}
		},
		[onChange, onExternalChange]
	);

	return (
		<Form.Counter
			name={name}
			value={value}
			onChange={onChangeValue}
			errors={!!error}
			{...props}
		/>
	);
};

FormFieldCounter.propTypes = {
	name: PropTypes.string.isRequired,
	control: PropTypes.object,
	onChange: PropTypes.func
};

FormFieldCounter.defaultProps = {
	control: {},
	onChange: () => {}
};

export default FormFieldCounter;
